import { makeAutoObservable } from "mobx";

export class AlertStore {
  rootStore;

  constructor(rootStore) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }

  showAlertSuccess = false;
  messageSuccess = undefined;

  showAlertError = false;
  messageError = undefined;

  messageInfo = undefined;
  showAlertInfo = false;

  alertCreateSuccess = (message) => {
    this.messageSuccess = message || "Registrado exitosamente";
    this.showAlertSuccess = true;
  };

  alertUpdateSuccess = (message) => {
    this.messageSuccess = message || "Actualizado exitosamente";
    this.showAlertSuccess = true;
  };

  alertDeleteSuccess = (message) => {
    this.messageSuccess = message || "Eliminado exitosamente";
    this.showAlertSuccess = true;
  };

  alertSuccess = (message) => {
    this.messageSuccess = message;
    this.showAlertSuccess = true;
  };

  closeAlertSuccess = () => {
    this.messageSuccess = undefined;
    this.showAlertSuccess = false;
  };

  alertError = (message) => {
    this.messageError = message;
    this.showAlertError = true;
  };

  closeAlertError = () => {
    this.messageError = undefined;
    this.showAlertError = false;
  };

  alertInfo = (message) => {
    this.messageInfo = message;
    this.showAlertInfo = true;    
  };

  closeAlertInfo = () => {
    this.messageInfo = undefined;
    this.showAlertInfo = false;    
  };
}
